<template>
  <div class="gmb-attributes-tree-node">
    <div class="group-name">{{ groupName }}</div>
    <div class="items">
      <template v-for="attribute in attributes">
        <div class="item" :key="attribute.attributeId">
          <GmbAttributeItemBool
            v-if="attribute.type === valueType.BOOL"
            :attribute-id="attribute.attributeId"
            :delete-mode="deleteMode"
          />
          <GmbAttributeItemEnum
            v-if="attribute.type === valueType.ENUM && !deleteMode"
            :attribute-id="attribute.attributeId"
            :delete-mode="deleteMode"
          />
          <GmbAttributeItemRepeatedEnum
            v-if="
              attribute.type === valueType.REPEATED_ENUM ||
                (attribute.type === valueType.ENUM && deleteMode)
            "
            :attribute-id="attribute.attributeId"
            :delete-mode="deleteMode"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { GmbAttributeValueType } from "@/enums/gmb-attribute-value-type";
import GmbAttributeItemBool from "@/components/FacilityDetails/GmbAttributes/GmbAttributeItemBool";
import GmbAttributeItemEnum from "@/components/FacilityDetails/GmbAttributes/GmbAttributeItemEnum";
import GmbAttributeItemRepeatedEnum from "@/components/FacilityDetails/GmbAttributes/GmbAttributeItemRepeatedEnum";

export default {
  name: "GmbAttributesTreeNode",
  components: {
    GmbAttributeItemBool,
    GmbAttributeItemEnum,
    GmbAttributeItemRepeatedEnum
  },
  props: {
    groupName: {
      type: String,
      required: true
    },
    attributes: {
      type: Array,
      required: true
    },
    deleteMode: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      valueType: GmbAttributeValueType,
      selectedAttributes: {}
    };
  },
  methods: {
    onItemChange(attributeId, value) {
      this.selectedAttributes[attributeId] = value;
      this.onNodeChange();
    },
    onNodeChange() {
      this.$emit("onChange", this.selectedAttributes);
    }
  }
};
</script>

<style lang="scss" scoped>
.gmb-attributes-tree-node {
  padding-top: 20px;
  padding-bottom: 15px;

  &:not(:last-of-type) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.07);
  }
}

.group-name {
  font-weight: 600;
  @include font-size(16px);
  line-height: 20px;
  color: $grey-darker;
  margin-bottom: $spacing * 1.25;
}
</style>
